var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94324 13.482C4.01638 13.482 4.88645 12.612 4.88645 11.5388C4.88645 10.4656 4.01638 9.59561 2.94324 9.59561C1.87002 9.59561 1 10.4656 1 11.5388C1 12.612 1.87002 13.482 2.94324 13.482Z",
    stroke: "#00E194",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 10.2461V2.66052C11.999 1.04712 10.9828 0.824275 9.95769 1.1006L6.08019 2.16134C5.376 2.35745 4.88574 2.91008 4.88574 3.72123V5.07622V5.98543V11.5387",
    stroke: "#00E194",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0567 12.1893C11.13 12.1893 11.9999 11.3193 11.9999 10.2461C11.9999 9.17299 11.13 8.30292 10.0567 8.30292C8.98351 8.30292 8.11353 9.17299 8.11353 10.2461C8.11353 11.3193 8.98351 12.1893 10.0567 12.1893Z",
    stroke: "#00E194",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88574 5.99423L11.999 4.05103",
    stroke: "#00E194",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c1.d74fce609fb221e6e61527b134452144.svg";
export { ForwardRef as ReactComponent };